import React from 'react';
import '../css/About.css';

function About() {
  const team = [
    { name: "Mor Agever", role: "CEO & Co-Founder" },
    { name: "Yakir Nisim", role: "CTO & Product Architect" },
    { name: "Adir Nisim", role: "Head of Logistics Partnerships" },
    { name: "Daniel Shepelev", role: "Lead Software Engineer" },
    { name: "Fatima Rahman", role: "Customer Success Manager" },
  ];

  return (
    <div className="about-container">
      <h1>About PortMatch</h1>
      <p>
        PortMatch is reshaping the way global logistics work by connecting shipping companies and freight forwarders on one intelligent platform.
      </p>
      <p>
        Our goal is to create a transparent, efficient, and cost-effective sea freight experience for businesses around the world. We do this by combining cutting-edge tech with deep industry experience.
      </p>

      <h2>Meet Our Team</h2>
      <div className="team-grid">
        {team.map((member, index) => (
          <div key={index} className="team-card">
            <div className="avatar">👤</div>
            <h3>{member.name}</h3>
            <p className="team-role">{member.role}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default About;
